import React, { useState, useRef, useEffect, useCallback } from "react";
import "./style.css";
const InputCode = ({ length, label, loading, onComplete }) => {
  const [code, setCode] = useState([...Array(length)].map(() => ""));
  const inputs = useRef([]);
  // Typescript
  // useRef<(HTMLInputElement | null)[]>([])

  const processInput = (e, slot) => {
    const num = e.target.value;
    if (/[^0-9]/.test(num)) return;
    const newCode = [...code];
    newCode[slot] = num;
    setCode(newCode);
    if (slot !== length - 1) {
      inputs.current[slot + 1].focus();
    }
    if (newCode.every((num) => num !== "")) {
      onComplete(newCode.join(""));
    }
  };

  const handlePaste = useCallback((e) => {
    let clipboardData, pastedData;

    //Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();

    // Get pasted data via clipboard API
    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    // Do whatever with pasteddata
    // alert(pastedData);
    //setCode(pastedData);
    const str = pastedData.slice(0, 6);
    const newcode = [...str];
    setCode(newcode);
    if (newcode.every((num) => num !== "")) {
      onComplete(newcode.join(""));
    }
  }, []);

  const onKeyUp = (e, slot) => {
    if (e.keyCode === 8 && !code[slot] && slot !== 0) {
      const newCode = [...code];
      newCode[slot - 1] = "";
      setCode(newCode);
      inputs.current[slot - 1].focus();
    }
  };

  useEffect(() => {
    const handleKeyDown = (ev) => {
      // function to check the detection
      ev = ev || window.event; // Event object 'ev'
      var key = ev.which || ev.keyCode; // Detecting keyCode
      const holaa = document.getElementById("holaa");

      // Detecting Ctrl
      var ctrl = ev.ctrlKey ? ev.ctrlKey : key === 17 ? true : false;

      // If key pressed is V and if ctrl is true.
      if ((key == 86 && ctrl) || ev.keyCode || ev.charCode || 0) {
        // print in console.
        if (holaa) holaa.addEventListener("paste", handlePaste);
      } else {
        if (ev.key === "Meta") {
        } else if (ev.key === "c") {
          if (holaa) holaa.addEventListener("paste", handlePaste);
        }
      }
    };
    document.body.addEventListener("keydown", handleKeyDown, false);
    return () => {
      document.body.removeEventListener("keydown", handleKeyDown, false);
    };
  }, [handlePaste]);

  return (
    <div className="code-input" id="holaa">
      <div className="code-inputs">
        {code.map((num, idx) => {
          return (
            <input
              className="focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-400 border-gray-100 rounded-md py-0.5 border block"
              key={idx}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={num}
              autoFocus={!code[0].length && idx === 0}
              readOnly={loading}
              onChange={(e) => processInput(e, idx)}
              onKeyUp={(e) => onKeyUp(e, idx)}
              ref={(ref) => inputs.current.push(ref)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InputCode;
